import { advanceQuoteDaysStates } from '@ourbranch/lookups';

export const offerUsesAdvanceQuoteDays = (state, policyType) => {
  if (!state || !policyType) {
    return false;
  }

  const adqState = advanceQuoteDaysStates[state];
  if (!adqState) {
    return false;
  }

  const policyTypes = policyType.split('');
  return policyTypes.some((type) => adqState[type] === true);
};
